/**
 * Hook to fetch and cache guest reliability data
 */
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '@/lib/backendUrl';


export const useGuestReliability = (guestEmails) => {
  const [reliabilityData, setReliabilityData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!guestEmails || guestEmails.length === 0) return;

    const fetchReliability = async () => {
      setLoading(true);
      const newData = {};
      
      // Fetch reliability for each unique email
      const uniqueEmails = [...new Set(guestEmails)];
      
      await Promise.all(
        uniqueEmails.map(async (email) => {
          try {
            const response = await axios.get(`${BACKEND_URL}/api/reliability/guest/${email}`);
            if (response.data.success) {
              newData[email] = {
                tier: response.data.reliability_tier,
                score: response.data.reliability_score
              };
            }
          } catch (error) {
            console.error(`Error fetching reliability for ${email}:`, error);
          }
        })
      );
      
      setReliabilityData(newData);
      setLoading(false);
    };

    fetchReliability();
  }, [JSON.stringify(guestEmails)]);

  return { reliabilityData, loading };
};
